var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var __target

module.exports = function description (model) {
elementOpen("div", "cdd0d067-c558-451f-ad75-bfccb56258bf", hoisted1)
  elementOpen("div")
    elementOpen("label", "1d8a2361-d931-4635-9660-056c524c7915", hoisted2)
      elementOpen("input", "26345bc0-a518-493b-b479-a0383b107466", hoisted3, "checked", model.required, "onchange", function ($event) {
        var $element = this;
      model.required = this.checked})
      elementClose("input")
      text(" Required \
          ")
    elementClose("label")
  elementClose("div")
elementClose("div")
}
